<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card hover>
          <v-card-title>Encuesta</v-card-title>
          <v-card-text>
            <v-text-field type="text" placeholder="Introduce aquí el código" v-model="code"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="$router.replace('poll/' + code)">Enviar</v-btn>
          </v-card-actions>
        </v-card>
        <br />
        <v-card hover>
          <v-card-title>Entrar</v-card-title>
          <v-card-text>
            <v-text-field type="text" placeholder="Usuario" v-model="email"></v-text-field>
            <v-text-field type="password" placeholder="Contraseña" v-model="password"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$router.replace('sign-up')">Crear usuario</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="login">Entrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase";
import vuetify from "../plugins/vuetify.js";

export default {
  name: "login",
  data() {
    return {
      code: "",
      email: "",
      password: ""
    };
  },
  methods: {
    login: function() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          console.log(user);
          this.$router.replace("home");
          this.$store.state.user = user;
        })
        .catch(error => {
          this.email = "";
          this.password = "";
          console.log("Ops: " + error.message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>